import logo from "Shared/theme/logo.png";

export const Logo = ({ ...props }) => <img src={logo} height={40} {...props} />;
